import * as R from "ramda";
import { ClientOutput } from "@src/global_functions/backpackSdk/client";

export const attachmentCipher = (
  data:
    | Array<ClientOutput["projects"]["ProjectAttachment"]>
    | Array<ClientOutput["projects"]["RewardReceipt"]>
    | Array<ClientOutput["rebates"]["RewardReceipt"]>
) => {
  return R.sortWith(
    [
      R.ascend(R.compose(R.toLower, R.prop("filename"))),
      R.ascend(R.prop("version")),
    ],
    data.map((attachment) => {
      const { uploaded_at, ...rest } = attachment;
      return {
        ...rest,
        uploaded_at: new Date(uploaded_at).toISOString(),
      };
    })
  );
};
